import type { Instrument } from '@/models/rfs';
import type { PropsWithChildren, ReactElement } from 'react';
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

const instrumentNameMapping = {
  Cash: 'cash',
  AmericanForward: 'american-forward',
} as const;

const CheckBoxeContainer = ({ className, dataE2e, disabled, children }: PropsWithChildren<{ className: string; dataE2e: string; disabled: boolean }>) => (
  <div className={disabled ? `${className} opacity-50 cursor-default` : className} data-e2e={dataE2e}>
    {children}
  </div>
);
const StyledCheckBoxeContainer = styled(CheckBoxeContainer)`height: 184px !important;`;

interface RadioCheckboxProps {
  instrument: Instrument;
  checkedInstrument: Instrument;
  disabled?: boolean;
}

export function RadioCheckbox({ children, instrument, checkedInstrument, disabled = false }: PropsWithChildren<RadioCheckboxProps>): ReactElement {
  const isChecked = checkedInstrument === instrument;

  return (
    <StyledCheckBoxeContainer className="card-checkbox bg-primary-alt p-16px" dataE2e={`${instrumentNameMapping[instrument]}-check-button`} disabled={disabled}>
      {/*HEADER*/}
      <div className="card-header d-flex align-items-center p-0 mb-8px">
        <div className="form-check">
          <input
            className="form-check-input z-0"
            type="radio"
            name="product-type"
            id={instrument}
            value={instrument}
            checked={isChecked}
            data-e2e={`${instrumentNameMapping[instrument]}-check-input`}
            disabled={disabled}
          />
        </div>
        <label className={`${isChecked ? '' : 'text-secondary '}fs-16 fw-semibold form-check-label ms-8px`} htmlFor={instrument}>
          <FormattedMessage id={`trader.checkbox.${instrument}`} />
        </label>
      </div>

      {/*BODY*/}
      <div className="card-body ps-24px pe-0 py-0">
        <div className="text-secondary ps-4px">
          <FormattedMessage id={`trader.checkbox.${instrument}.description`} />
        </div>
        {children}
      </div>
    </StyledCheckBoxeContainer>
  );
}
